import React, { useEffect, useState } from "react";
import { Stack, Text, PrimaryButton, ChoiceGroup, IChoiceGroupOption } from "@fluentui/react";
import { AccountRegService } from "../../services";
import { IAccountReg } from "../../types";

interface Props {
    email: string;
    accountRegId: number;
    onContinue: (useExisting: boolean) => void;
}

export const StepAccountSelection: React.FC<Props> = ({ email, accountRegId, onContinue }) => {
    const accountRegService = new AccountRegService();

    const [accounts, setAccounts] = useState<string[]>([]);
    const [selectedKey, setSelectedKey] = useState<string>("existing");

    useEffect(() => {
        const loadAccounts = async () => {
            try {
                const data = await accountRegService.getByEmail(email);
                setAccounts(data);
            } catch (err) {
                console.error("Failed to load accounts", err);
            }
        };

        loadAccounts();
    }, [email]);

    const options: IChoiceGroupOption[] = [
        {
            key: "existing",
            text: "Use existing account and finish"
        },
        {
            key: "new",
            text: "Create a new account"
        }
    ];

    const handleContinue = () => {
        onContinue(selectedKey === "existing");
    };

    return (
        <Stack tokens={{ childrenGap: 20 }} styles={{ root: { maxWidth: 500 } }}>
            <Text variant="xLarge">Account Found</Text>

            <Text>
                We found existing account(s) with this email. If you already have access, you can use one of these instead of creating a new account.
            </Text>

            {/* Read-only list */}
            <Stack tokens={{ childrenGap: 5 }}>
                {accounts.map((customerRef, index) => (
                    <Text key={index}>
                        • {customerRef}
                    </Text>
                ))}
            </Stack>

            {/* Decision */}
            <ChoiceGroup
                selectedKey={selectedKey}
                onChange={(_, option) => setSelectedKey(option?.key as string)}
                options={options}
            />


            <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: 12, padding: 0 }} className="step-actions-btns">
                <PrimaryButton text="Continue" onClick={handleContinue} />
            </Stack>
        </Stack>
    );
};